module.exports = __webpack_public_path__ + "img/5-3.fd48c5cb.svg";